"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var player_api_decorator_1 = (0, tslib_1.__importDefault)(require("../../../core/player-api-decorator"));
var adapter_1 = require("./adapter");
var PreviewService = /** @class */ (function () {
    function PreviewService(_a) {
        var engine = _a.engine;
        this._engine = engine;
    }
    PreviewService.prototype.setFramesMap = function (map) {
        this._framesMap = map;
    };
    PreviewService.prototype.getAt = function (second) {
        if (!this._framesMap) {
            return;
        }
        var duration = this._engine.getDuration();
        if (!duration) {
            return;
        }
        return (0, adapter_1.getAt)(this._framesMap, second, duration);
    };
    PreviewService.prototype.destroy = function () {
        this._framesMap = null;
    };
    PreviewService.moduleName = 'previewService';
    PreviewService.dependencies = ['engine'];
    (0, tslib_1.__decorate)([
        (0, player_api_decorator_1.default)()
    ], PreviewService.prototype, "setFramesMap", null);
    return PreviewService;
}());
exports.default = PreviewService;
//# sourceMappingURL=preview-service.js.map